import { defineComponent, reactive } from 'vue';
export default defineComponent({
  name: "BuyView",

  setup() {
    let setupData = reactive({});
    return setupData;
  }

});